import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import ModalContentBase from '../modal_content_base';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    myPref: PropTypes.object,
    countriesPrefs: PropTypes.array,
    currentUser: PropTypes.object,
    isSearchbuttomDisplay: PropTypes.bool,
  },
  getInitialState() {
    return {
      myPrefId:
        Object.keys(this.props.myPref).length > 0 ? this.props.myPref.id : 0,
      isLoading: false,
    };
  },
  closeModalPrefSelector() {
    this.modalPrefSelector.closeModal();
  },
  handlePrefChange(e) {
    this.setState(
      {
        isLoading: true,
        myPrefId: e.target.value,
      },
      () => {
        Object.keys(this.props.currentUser).length > 0
          ? this.updateMyPref()
          : this.updateUsersPrefsCookie();
      }
    );
  },
  updateMyPref() {
    $.ajax({
      url: '/api/user',
      type: 'PATCH',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        user: {
          pref_id_1: this.state.myPrefId,
          city_id_1: null,
        },
      },
    })
      .done(
        function () {
          this.reloadPage();
        }.bind(this)
      )
      .fail(function () {}.bind(this));
  },
  updateUsersPrefsCookie() {
    $.ajax({
      url: '/api/user/cookie_pref_setting',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        pref_id: this.state.myPrefId,
      },
    })
      .done(
        function () {
          this.reloadPage();
        }.bind(this)
      )
      .fail(function () {}.bind(this));
  },
  reloadPage() {
    var prefKeys = {
      1: 'hokkaido',
      2: 'aomori',
      3: 'iwate',
      4: 'miyagi',
      5: 'akita',
      6: 'yamagata',
      7: 'fukushima',
      8: 'ibaraki',
      9: 'tochigi',
      10: 'gunma',
      11: 'saitama',
      12: 'chiba',
      13: 'tokyo',
      14: 'kanagawa',
      15: 'niigata',
      16: 'toyama',
      17: 'ishikawa',
      18: 'fukui',
      19: 'yamanashi',
      20: 'nagano',
      21: 'gifu',
      22: 'shizuoka',
      23: 'aichi',
      24: 'mie',
      25: 'shiga',
      26: 'kyoto',
      27: 'osaka',
      28: 'hyogo',
      29: 'nara',
      30: 'wakayama',
      31: 'tottori',
      32: 'shimane',
      33: 'okayama',
      34: 'hiroshima',
      35: 'yamaguchi',
      36: 'tokushima',
      37: 'kagawa',
      38: 'ehime',
      39: 'kochi',
      40: 'fukuoka',
      41: 'saga',
      42: 'nagasaki',
      43: 'kumamoto',
      44: 'oita',
      45: 'miyazaki',
      46: 'kagoshima',
      47: 'okinawa',
    };
    var pathname = location.pathname;

    if (
      pathname === '/' || // pathname.match(/\d+/) ||
      pathname.match(/coupons\/events\/\d+/) ||
      pathname.match('/userfeeds')
    ) {
      location.reload();
    } else {
      var pathnameArray = pathname.split('/');
      var mainGenreKey = pathnameArray[1];
      // var prefKey = pathnameArray[2];
      var subGenreKey = pathnameArray[3];
      if (this.state.myPrefId && !subGenreKey) {
        location.href = `/${mainGenreKey}/${prefKeys[this.state.myPrefId]}`;
      } else if (this.state.myPrefId && subGenreKey) {
        location.href = `/${mainGenreKey}/${
          prefKeys[this.state.myPrefId]
        }/${subGenreKey}`;
      } else {
        location.href = `/${mainGenreKey}`;
      }
    }
  },

  // キーワード検索
  onKeyDown(e) {
      if (e.keyCode === 13) {
        var keyword = e.target.value;
        location.href = `/search/${Object.keys(this.props.myPref).length > 0
          ? this.props.myPref.pref_key
          : 'all'}?keyword=${keyword}`
        return false;
      }
  },

  render() {
    const previewContent = (
      <div className="search-box p-2">
        <div className="row align-items-center justify-content-between line-height-1 cursor-pointer">
          <p className="text-black-80 text-reset col-auto mb-0 icon icon-area icon-area-gray">
            {Object.keys(this.props.myPref).length > 0
              ? this.props.myPref.name
              : '全国'}
          </p>
        </div>
      </div>
    );

    const countriesPrefs = this.props.countriesPrefs.map((pref) => {
      return (
        <li className="nav-item p-3 border-bottom" key={pref.id}>
          <input
            type="radio"
            name="pref"
            id={pref.id}
            className="d-none checkbox__input checkbox__area"
            value={pref.id}
            onChange={this.handlePrefChange}
            defaultChecked={pref.id === this.state.myPrefId}
          />
          <label
            className="d-flex justify-content-between align-items-center mb-0 position-relative"
            htmlFor={pref.id}
          >
            <span className="p-0 line-height-2 pl-3 mb-0">{pref.name}</span>
            <span className="checkbox__lg checkbox__noborder" />
          </label>
        </li>
      );
    });

    const modalContent = (
      <div className="card bg-gray pt-3">
        <button
          type="button"
          className="close close__modal position-absolute position--modalclose"
          aria-label="Close"
          onClick={this.closeModalPrefSelector}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h6 className="text-fw-bold text-center mb-3_5">
          地域を選択してください
        </h6>
        <div className="card bg-white h-100">
          <ul className="nav flex-column">{countriesPrefs}</ul>
        </div>
      </div>
    );
    return (
      <div className="fixed-search-box w-100 text-fz-14px bg-white">
        <div className="container col-lg-8 mb-2">
          <ModalContentBase
            ref={(c) => {
            this.modalPrefSelector = c;
            }}
            previewContent={previewContent}
            modalContent={modalContent}
          />
        </div>
      </div>
    );
  },
});